// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableFeatures_header__bv7JM {
  font-size: 20px;
  font-weight: 700;
  line-height: 35px;
}
.TableFeatures_headerIcon__Ug6mJ {
  padding-inline-end: 8px;
}
.TableFeatures_container__60m7G {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 0 10px;
}
.TableFeatures_endPart__4kF70 {
  display: flex;
  align-items: center;
  column-gap: 16px;
}
.TableFeatures_startPart__HpsVD {
  display: flex;
  align-items: center;
  column-gap: 6px;
}
.TableFeatures_tableFeatureIcon__gZqHA {
  color: #787878;
  fill: #787878;
  cursor: pointer;
  transition: all 0.2s ease-out !important ;
}
.TableFeatures_tableFeatureIcon__gZqHA:hover {
  color: #414141;
  fill: #414141;
  transform: scale(1.2);
}
.TableFeatures_addTableFeatureContainer__Wouve {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #3963b8;
  color: #fff;
  fill: #fff;
  border-radius: 4px;
  padding-inline-start: 3px;
  padding-inline-end: 9px;
  padding-block: 3px;
  column-gap: 4px;
}
.TableFeatures_addBtnTooltip__qmHdc {
  visibility: hidden;
  text-align: center;
  border-radius: 4px;
  padding: 5px 10px;
  position: absolute;
  z-index: 1;
  background-color: var(--sidebar-background-color);
  color: #fff;
  opacity: 0;
  left: -7px;
  top: -48px;
  transition: all 0.4s ease-out;
}
.TableFeatures_addBtnTooltip__qmHdc::after {
  content: "";
  position: absolute;
  background-color: var(--sidebar-background-color);
  width: 20px;
  height: 20px;
  left: 10px;
  bottom: -15px;
  clip-path: polygon(50% 80%, 0 0, 100% 0);
}
.TableFeatures_addTableFeatureContainer__Wouve:hover .TableFeatures_addBtnTooltip__qmHdc {
  visibility: visible;
  opacity: 1;
}
.TableFeatures_addTableFeatureIconContainer__tw4we,
.TableFeatures_addTableFeatureTxtContainer__Cjvx9 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.TableFeatures_addTableFeatureTxtContainer__Cjvx9 {
  transform: translateY(1px);
}
.TableFeatures_selectAllInput__9mEv4 {
  width: 16px;
  height: 16px;
  margin-inline-start: 21px;
}
.TableFeatures_ColumnEditSpanContainer__PuAz1 {
  position: absolute !important;
  background-color: #fff;
  padding: 4px 0;
  z-index: 21;
  top: 41px !important ;
  /* min-width: 180px; */
  margin-inline-start: -50px;
  border-radius: 4px;
  box-shadow: #0717391f 0px 0px 5px, #0717391f 0px 1px 5px;
  white-space: nowrap !important;
  scroll-behavior: smooth !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important;
  max-height: 600px !important;
}
.TableFeatures_columnEditBackDrop__SGOcb {
  position: fixed;
  top: 0;
  background-color: transparent;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 20;
}
.TableFeatures_ColumnEditSpanContainer__PuAz1::-webkit-scrollbar {
  width: 8px;
  height: 180px !important;
}
.TableFeatures_ColumnEditSpanContainer__PuAz1::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px #8fa4c3;
  background-color: #fff;
}
.TableFeatures_ColumnEditSpanContainer__PuAz1::-webkit-scrollbar-thumb {
  background-color: #274684;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 100px;
}
.TableFeatures_scrollColumnEditSpanContainer__wcYdV {
  padding: 4px 0;
}
.TableFeatures_columnPersonlizer__fq4q5 {
  color: #787878;
  padding-inline-start: 8px;
  font-size: 13px;
  padding-block: 6px 12px;
  border-bottom: 1px solid #bbc0ca;
}
.TableFeatures_columns__L\\+mCk {
  color: #787878;
  padding-inline-start: 8px;
  padding-block: 10px;
  font-size: 13px;
}
.TableFeatures_ColumnEditLine__Vozp7 {
  padding-inline-start: 8px;
  padding-inline-end: 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row-reverse;
  column-gap: 8px;
  height: 38px !important;
}
.TableFeatures_ColumnEditLine__Vozp7 label {
  cursor: pointer;
}
.TableFeatures_ColumnEditLine__Vozp7:hover {
  background-color: #c1e3ff;
}
.TableFeatures_ColumnEditLineCheckBox__yT7ID {
  appearance: none;
  position: relative;
  width: 18px;
  height: 18px;
  background-color: #fff;
  border-radius: 3px;
  border: 1px solid rgba(28, 57, 187, 0.486);
  cursor: pointer;
}
.TableFeatures_ColumnEditLineCheckBox__yT7ID:checked {
  background-color: rgb(28, 57, 187);
  border: none;
}
.TableFeatures_ColumnEditLineCheckBox__yT7ID:checked::before {
  content: "\\2713";
  font-family: Estedad !important;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  position: absolute;
  top: -4px;
  left: 2px;
}
.TableFeatures_checkboxEditColumns__OTBiS {
  color: #787878;
  font-weight: 400;
  flex-grow: 1;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 13px;
}
.TableFeatures_fullScreenIconContainer__nsD2h,
.TableFeatures_rowIconContainer__OfDl-,
.TableFeatures_columnIconContainer__IQB76,
.TableFeatures_searchIconContainer__lUg0I {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media all and (max-width: 400px) {
  .TableFeatures_endPart__4kF70 {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }
}
/* @media all and (max-width: 600px) {
  .ColumnEditSpanContainer {
    min-width: 90%;
    width: 90%;
    right: 5%;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/Components/NewTable/TableFeatures/TableFeatures.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,iDAAiD;EACjD,WAAW;EACX,UAAU;EACV,UAAU;EACV,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iDAAiD;EACjD,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,wCAAwC;AAC1C;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,wDAAwD;EACxD,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,4CAA4C;EAC5C,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,MAAM;EACN,6BAA6B;EAC7B,OAAO;EACP,WAAW;EACX,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;;;;EAIE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;;;;;;GAMG","sourcesContent":[".header {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  line-height: 35px;\r\n}\r\n.headerIcon {\r\n  padding-inline-end: 8px;\r\n}\r\n.container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  width: 100%;\r\n  padding: 0 10px;\r\n}\r\n.endPart {\r\n  display: flex;\r\n  align-items: center;\r\n  column-gap: 16px;\r\n}\r\n.startPart {\r\n  display: flex;\r\n  align-items: center;\r\n  column-gap: 6px;\r\n}\r\n.tableFeatureIcon {\r\n  color: #787878;\r\n  fill: #787878;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease-out !important ;\r\n}\r\n.tableFeatureIcon:hover {\r\n  color: #414141;\r\n  fill: #414141;\r\n  transform: scale(1.2);\r\n}\r\n.addTableFeatureContainer {\r\n  position: relative;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #3963b8;\r\n  color: #fff;\r\n  fill: #fff;\r\n  border-radius: 4px;\r\n  padding-inline-start: 3px;\r\n  padding-inline-end: 9px;\r\n  padding-block: 3px;\r\n  column-gap: 4px;\r\n}\r\n.addBtnTooltip {\r\n  visibility: hidden;\r\n  text-align: center;\r\n  border-radius: 4px;\r\n  padding: 5px 10px;\r\n  position: absolute;\r\n  z-index: 1;\r\n  background-color: var(--sidebar-background-color);\r\n  color: #fff;\r\n  opacity: 0;\r\n  left: -7px;\r\n  top: -48px;\r\n  transition: all 0.4s ease-out;\r\n}\r\n.addBtnTooltip::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  background-color: var(--sidebar-background-color);\r\n  width: 20px;\r\n  height: 20px;\r\n  left: 10px;\r\n  bottom: -15px;\r\n  clip-path: polygon(50% 80%, 0 0, 100% 0);\r\n}\r\n.addTableFeatureContainer:hover .addBtnTooltip {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n.addTableFeatureIconContainer,\r\n.addTableFeatureTxtContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.addTableFeatureTxtContainer {\r\n  transform: translateY(1px);\r\n}\r\n.selectAllInput {\r\n  width: 16px;\r\n  height: 16px;\r\n  margin-inline-start: 21px;\r\n}\r\n.ColumnEditSpanContainer {\r\n  position: absolute !important;\r\n  background-color: #fff;\r\n  padding: 4px 0;\r\n  z-index: 21;\r\n  top: 41px !important ;\r\n  /* min-width: 180px; */\r\n  margin-inline-start: -50px;\r\n  border-radius: 4px;\r\n  box-shadow: #0717391f 0px 0px 5px, #0717391f 0px 1px 5px;\r\n  white-space: nowrap !important;\r\n  scroll-behavior: smooth !important;\r\n  overflow-y: auto !important;\r\n  -webkit-overflow-scrolling: touch !important;\r\n  max-height: 600px !important;\r\n}\r\n.columnEditBackDrop {\r\n  position: fixed;\r\n  top: 0;\r\n  background-color: transparent;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  z-index: 20;\r\n}\r\n.ColumnEditSpanContainer::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 180px !important;\r\n}\r\n.ColumnEditSpanContainer::-webkit-scrollbar-track {\r\n  box-shadow: inset 0 0 6px #8fa4c3;\r\n  background-color: #fff;\r\n}\r\n.ColumnEditSpanContainer::-webkit-scrollbar-thumb {\r\n  background-color: #274684;\r\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n  border-radius: 100px;\r\n}\r\n.scrollColumnEditSpanContainer {\r\n  padding: 4px 0;\r\n}\r\n.columnPersonlizer {\r\n  color: #787878;\r\n  padding-inline-start: 8px;\r\n  font-size: 13px;\r\n  padding-block: 6px 12px;\r\n  border-bottom: 1px solid #bbc0ca;\r\n}\r\n.columns {\r\n  color: #787878;\r\n  padding-inline-start: 8px;\r\n  padding-block: 10px;\r\n  font-size: 13px;\r\n}\r\n.ColumnEditLine {\r\n  padding-inline-start: 8px;\r\n  padding-inline-end: 26px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-direction: row-reverse;\r\n  column-gap: 8px;\r\n  height: 38px !important;\r\n}\r\n.ColumnEditLine label {\r\n  cursor: pointer;\r\n}\r\n.ColumnEditLine:hover {\r\n  background-color: #c1e3ff;\r\n}\r\n.ColumnEditLineCheckBox {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  position: relative;\r\n  width: 18px;\r\n  height: 18px;\r\n  background-color: #fff;\r\n  border-radius: 3px;\r\n  border: 1px solid rgba(28, 57, 187, 0.486);\r\n  cursor: pointer;\r\n}\r\n.ColumnEditLineCheckBox:checked {\r\n  background-color: rgb(28, 57, 187);\r\n  border: none;\r\n}\r\n.ColumnEditLineCheckBox:checked::before {\r\n  content: \"\\2713\";\r\n  font-family: Estedad !important;\r\n  color: #fff;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  position: absolute;\r\n  top: -4px;\r\n  left: 2px;\r\n}\r\n.checkboxEditColumns {\r\n  color: #787878;\r\n  font-weight: 400;\r\n  flex-grow: 1;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 13px;\r\n}\r\n.fullScreenIconContainer,\r\n.rowIconContainer,\r\n.columnIconContainer,\r\n.searchIconContainer {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n@media all and (max-width: 400px) {\r\n  .endPart {\r\n    display: flex;\r\n    align-items: center;\r\n    column-gap: 8px;\r\n  }\r\n}\r\n/* @media all and (max-width: 600px) {\r\n  .ColumnEditSpanContainer {\r\n    min-width: 90%;\r\n    width: 90%;\r\n    right: 5%;\r\n  }\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `TableFeatures_header__bv7JM`,
	"headerIcon": `TableFeatures_headerIcon__Ug6mJ`,
	"container": `TableFeatures_container__60m7G`,
	"endPart": `TableFeatures_endPart__4kF70`,
	"startPart": `TableFeatures_startPart__HpsVD`,
	"tableFeatureIcon": `TableFeatures_tableFeatureIcon__gZqHA`,
	"addTableFeatureContainer": `TableFeatures_addTableFeatureContainer__Wouve`,
	"addBtnTooltip": `TableFeatures_addBtnTooltip__qmHdc`,
	"addTableFeatureIconContainer": `TableFeatures_addTableFeatureIconContainer__tw4we`,
	"addTableFeatureTxtContainer": `TableFeatures_addTableFeatureTxtContainer__Cjvx9`,
	"selectAllInput": `TableFeatures_selectAllInput__9mEv4`,
	"ColumnEditSpanContainer": `TableFeatures_ColumnEditSpanContainer__PuAz1`,
	"columnEditBackDrop": `TableFeatures_columnEditBackDrop__SGOcb`,
	"scrollColumnEditSpanContainer": `TableFeatures_scrollColumnEditSpanContainer__wcYdV`,
	"columnPersonlizer": `TableFeatures_columnPersonlizer__fq4q5`,
	"columns": `TableFeatures_columns__L+mCk`,
	"ColumnEditLine": `TableFeatures_ColumnEditLine__Vozp7`,
	"ColumnEditLineCheckBox": `TableFeatures_ColumnEditLineCheckBox__yT7ID`,
	"checkboxEditColumns": `TableFeatures_checkboxEditColumns__OTBiS`,
	"fullScreenIconContainer": `TableFeatures_fullScreenIconContainer__nsD2h`,
	"rowIconContainer": `TableFeatures_rowIconContainer__OfDl-`,
	"columnIconContainer": `TableFeatures_columnIconContainer__IQB76`,
	"searchIconContainer": `TableFeatures_searchIconContainer__lUg0I`
};
export default ___CSS_LOADER_EXPORT___;
